import { yup } from '@framework/validation';
import { fromPairs } from 'lodash';
import { FormBuilderMetaFlags } from '../../../../../validator';
import { ICreateWidgetFormSchemaInput } from '../../../IWidgetType';
import { getDatatypeOutputSchema } from '../../common/async-widgets/getDatatypeOutputSchema';
import { asyncValueWidgetObjectName } from './AsyncValueWidget.type';
import { IAsyncValueWidget } from './IAsyncValueWidget';

export function createAsyncValueFormSchema(
  input: ICreateWidgetFormSchemaInput<IAsyncValueWidget>,
) {
  const { widget } = input;

  const outputs = widget.outputs ?? [];

  const objectSchema = yup
    .object(
      fromPairs(
        outputs.map(output => [
          output.name,
          getDatatypeOutputSchema(output.type),
        ]),
      ),
    )
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );

  return {
    [widget.code]: yup.string().notRequired(),
    [asyncValueWidgetObjectName(widget.code)]: objectSchema
      .noUnknown()
      .notRequired(),
  };
}
